// extracted by mini-css-extract-plugin
export default {"tabs":"navigation_tabs__vH3kl","tab":"navigation_tab__4hKIJ","contentContainer":"navigation_contentContainer__HAjZW"};